import StateMixin from '@/components/report/mixins/StateMixin'

export default {
  mixins: [ StateMixin ],
  props: {
    data: {
      type: Object,
      required: true,
      validator ( val ) {
        return !!val.txt
      }
    }
  },
  computed: {
    size () {
      return this.data.size || 16
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/report/mixins/TextMixin.js